module.exports = __webpack_public_path__ + "img/button-text-bulleted-list.78818b2.svg";